import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';
import { selectors as marketSelectors } from '@clearscore/redux.market';

const getActiveMarket = (state) => marketSelectors.getActiveMarket(state);
const getAllRoles = (state) => resolveProp('identity.fetchUserInfo.data.groups', state);

export default createSelector(getAllRoles, getActiveMarket, (roles, activeMarket) => roles && roles[activeMarket]);
